/* decommission 
import termsBodykeyPP from '../views/amwayterms/termsBodykeyPP'
import termsBodykeyTC from '../views/amwayterms/termsBodykeyTC'
import termsBodykeyPIM from '../views/amwayterms/termsBodykeyPIM'
import termsBodykeyPIC from '../views/amwayterms/termsBodykeyPIC'
import termsBodykeySI from '../views/amwayterms/termsBodykeySI'
import termsBodykeySIO from '../views/amwayterms/termsBodykeySIO'
import termsBodykeySIP from '../views/amwayterms/termsBodykeySIP'
import termsBodykeyPIP from '../views/amwayterms/termsBodykeyPIP'
*/

const termsAbo = () => import('../views/amwayterms/termsAbo')
const termsMember = () => import('../views/amwayterms/termsMember')
const termsCustomer = () => import('../views/amwayterms/termsCustomer')
const termsClubtaola = () => import('../views/amwayterms/termsClubtaola')
const termsBasksop = () => import('../views/amwayterms/termsBasksop')

export default [
    {
      path: '/abo/abo_terms',
      name: 'termsAbo',
      component: termsAbo
    },
    {
      path: '/member/member_terms',
      name: 'termsMember',
      component: termsMember
    },
    {
      path: '/customer/customer_terms',
      name: 'termsCustomer',
      component: termsCustomer
    },
    {
      path: '/terms/abo',
      name: 'termsAbo',
      component: termsAbo
    },
    {
      path: '/terms/member',
      name: 'termsMember',
      component: termsMember
    },
    {
      path: '/terms/customer',
      name: 'termsCustomer',
      component: termsCustomer
    },
    {
      path: '/terms/clubtaola',
      name: 'termsClubtaola',
      component: termsClubtaola
    },
    {
      path: '/terms/basketsop',
      name: 'termsBasketsop',
      component: termsBasksop
    },
  ]